<template>
  <news-detail :is-edit="false" />
</template>

<script>
import NewsDetail from "./components/newsDetail";

export default {
  name: "EditForm",
  components: { NewsDetail },
};
</script>
